package io.github.kingsword09.symbolcraft.symbols.icons.svgl.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.svgl.Icons

public val Icons.XboxSvgl: ImageVector
    get() {
        if (_xboxSvgl != null) {
            return _xboxSvgl!!
        }
        _xboxSvgl = Builder(name = "XboxSvgl", defaultWidth = 88.0.dp, defaultHeight = 88.0.dp, viewportWidth = 88.0f, viewportHeight = 88.0f).apply {
            path(fill = SolidColor(Color(0xFF107c10)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(39.73f, 86.91f)
                curveToRelative(-6.63f, -0.64f, -13.34f, -3.02f, -19.10f, -6.78f)
                curveToRelative(-4.83f, -3.15f, -5.92f, -4.45f, -5.92f, -7.03f)
                curveToRelative(0.0f, -5.19f, 5.71f, -14.29f, 15.48f, -24.66f)
                curveToRelative(5.55f, -5.89f, 13.28f, -12.79f, 14.11f, -12.60f)
                curveToRelative(1.63f, 0.36f, 14.62f, 13.03f, 19.48f, 19.0f)
                curveToRelative(7.69f, 9.43f, 11.22f, 17.15f, 9.43f, 20.60f)
                curveToRelative(-1.37f, 2.62f, -9.84f, 7.73f, -16.06f, 9.70f)
                curveToRelative(-5.13f, 1.62f, -11.87f, 2.31f, -17.42f, 1.78f)
                close()
                moveTo(8.18f, 67.70f)
                curveToRelative(-4.01f, -6.16f, -6.04f, -12.22f, -7.02f, -20.99f)
                curveToRelative(-0.32f, -2.90f, -0.21f, -4.55f, 0.73f, -10.49f)
                curveToRelative(1.17f, -7.4f, 5.39f, -15.97f, 10.46f, -21.24f)
                curveToRelative(2.16f, -2.24f, 2.35f, -2.3f, 4.98f, -1.41f)
                curveToRelative(3.19f, 1.08f, 6.6f, 3.44f, 11.89f, 8.22f)
                lineToRelative(3.09f, 2.79f)
                lineToRelative(-1.69f, 2.07f)
                curveToRelative(-7.83f, 9.61f, -16.09f, 23.24f, -19.2f, 31.67f)
                curveToRelative(-1.69f, 4.58f, -2.37f, 9.18f, -1.64f, 11.10f)
                curveToRelative(0.49f, 1.29f, 0.04f, 0.81f, -1.61f, -1.71f)
                close()
                moveTo(78.64f, 68.75f)
                curveToRelative(0.40f, -1.94f, -0.11f, -5.49f, -1.28f, -9.08f)
                curveToRelative(-2.55f, -7.77f, -11.05f, -22.21f, -18.87f, -32.03f)
                lineToRelative(-2.46f, -3.09f)
                lineToRelative(2.66f, -2.44f)
                curveToRelative(3.47f, -3.19f, 5.89f, -5.1f, 8.49f, -6.72f)
                curveToRelative(2.05f, -1.28f, 4.99f, -2.41f, 6.25f, -2.41f)
                curveToRelative(0.78f, 0.0f, 3.52f, 2.85f, 5.73f, 5.95f)
                curveToRelative(3.42f, 4.8f, 5.94f, 10.63f, 7.22f, 16.69f)
                curveToRelative(0.83f, 3.92f, 0.89f, 12.3f, 0.13f, 16.21f)
                curveToRelative(-0.63f, 3.21f, -1.95f, 7.37f, -3.23f, 10.19f)
                curveToRelative(-0.97f, 2.11f, -3.36f, 6.22f, -4.41f, 7.55f)
                curveToRelative(-0.54f, 0.69f, -0.54f, 0.69f, -0.24f, -0.80f)
                close()
                moveTo(40.44f, 11.51f)
                curveTo(36.83f, 9.68f, 31.27f, 7.71f, 28.2f, 7.18f)
                curveToRelative(-1.08f, -0.19f, -2.91f, -0.29f, -4.08f, -0.23f)
                curveToRelative(-2.54f, 0.13f, -2.42f, -0.00f, 1.64f, -1.93f)
                curveToRelative(3.38f, -1.60f, 6.2f, -2.54f, 10.03f, -3.34f)
                curveTo(40.10f, 0.78f, 48.19f, 0.77f, 52.43f, 1.66f)
                curveToRelative(4.58f, 0.97f, 9.96f, 2.97f, 13.0f, 4.84f)
                lineToRelative(0.90f, 0.55f)
                lineToRelative(-2.07f, -0.10f)
                curveTo(60.15f, 6.75f, 54.15f, 8.41f, 47.71f, 11.54f)
                curveToRelative(-1.94f, 0.95f, -3.63f, 1.7f, -3.75f, 1.68f)
                curveToRelative(-0.12f, -0.02f, -1.71f, -0.80f, -3.52f, -1.72f)
                close()
            }
        }
        .build()
        return _xboxSvgl!!
    }

private var _xboxSvgl: ImageVector? = null
